<template>
  <div class="page-container">
    <div class="search-wrapper">
      <Row class="margin-left-16 box-title-mt-32">
        <Col span="16">
          <Form
            ref="formApply"
            label-position="right"
            :model="formApply"
            :rules="ruleValidate"
            :label-width="140"
          >
            <!-- <FormItem label="素质课限报：" prop="qualityLimit">
              <Row>
                <Col span="6">
                  <Input
                    v-model="formApply.qualityLimit"
                    placeholder="请填写"
                  ></Input>
                </Col>
                <Col offset="1" span="4">
                  {{ '节' }}
                </Col>
              </Row>
              <p class="color-gray font-small">
                每学期每人仅能报名素质课程数，不填则不限制
              </p>
            </FormItem>
            <FormItem label="基础托管限报：" prop="baseHostingLimit">
              <Row>
                <Col span="6">
                  <Input
                    v-model="formApply.baseHostingLimit"
                    placeholder="请填写"
                  ></Input>
                </Col>
                <Col offset="1" span="4">
                  {{ '节' }}
                </Col>
              </Row>
              <p class="color-gray font-small">
                每学期每人仅能报名基础托管课程数，不填则不限制
              </p>
            </FormItem>
            <FormItem label="配餐限报：" prop="cateringLimit">
              <Row>
                <Col span="6">
                  <Input
                    v-model="formApply.cateringLimit"
                    :disabled="disable"
                    placeholder="请填写"
                  ></Input>
                </Col>
                <Col offset="1" span="4">
                  {{ '节' }}
                </Col>
              </Row>
              <p class="color-gray font-small">
                每学期每人仅能报名配餐数，不填则不限制
              </p>
            </FormItem> -->
            <FormItem label="周次同时段下最大报名数：" prop="numCod">
              <Row>
                <Col span="6">
                  <Input
                    v-model="formApply.numCod"
                    :disabled="maxCod"
                    placeholder="请填写"
                  ></Input>
                </Col>
                <Col offset="1" span="8">
                  <Checkbox
                    v-model="maxCod"
                    @on-change="onMaxCodChange"
                  >不限</Checkbox>
                </Col>
              </Row>
              <p class="color-gray font-small">
                1.
                同一个周次下(周一、周二等)，允许同时段报名课程商品数量，若同时段报名课程时间段冲突数大于所设置，则将不允许报名
              </p>
              <p class="color-gray font-small">
                2. 不限：表示不校验任何周次时间段下的冲突课程
              </p>
            </FormItem>
          </Form>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
// import CheckSchool from './assets/components/CheckSchool';
import courseCenterApi from '@/request/courseCenter/courseCenterApi.js';
export default {
  name: 'CourseOthers',
  props: {
    schoolId: {
      type: String,
      default: ''
    },
    otherInfo: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    const checkNum = (rule, value, callback) => {
      const r = /^\d+$/;
      if (isNaN(value)) {
        return callback('请输入数字');
      } else if (r.test(value) || value === '') {
        return callback();
      } else {
        return callback('请输入非负整数');
      }
    };
    return {
      orgId: '',
      portOpera: true, // 判断是否运营端
      maxCod: true,
      formApply: { // 表单信息--报名设置
        qualityLimit: '',
        baseHostingLimit: '',
        cateringLimit: '',
        numCod: 0
      },
      ruleValidate: { // 验证规则--课程分类
        // qualityLimit: [
        //   { validator: checkNum, trigger: 'blur' }],
        // baseHostingLimit: [
        //   { validator: checkNum, trigger: 'blur' }],
        // cateringLimit: [
        //   { validator: checkNum, trigger: 'blur' }],
        numCod: [
          { validator: checkNum, trigger: 'blur' }]
      },
      addSysStaticDataList: [],
      formSave: {},
      disable: false,
      portOrg: -1 // 处于哪个端
    };
  },
  created() {
    this.portOrg = Number(localStorage.getItem('portOrg'));
    this.getOtherSetting();
  },
  methods: {
    handleChangeSchool(id) {
      this.orgId = id;
      this.getOtherSetting();
    },
    // 获取其他设置信息
    async getOtherSetting() {
      const params = {
        orgId: this.schoolId
      };
      try {
        const res = await courseCenterApi.getOtherSettingNew(params);
        if (res.status === 200) {
          console.log(res.message);
          for (const key in res.message) {
            res.message[key] = (res.message[key] === null) ? '' : res.message[key];
          }
          this.formApply = res.message;

          if (res.message.sameTimeEnrollLimit) {
            this.maxCod = false;
            this.formApply.numCod = res.message.sameTimeEnrollLimit;
          } else {
            this.maxCod = true;
            this.formApply.numCod = '';
          }
          this.$emit('on-message', res.message);
        }
      } catch (err) {
        console.log('err', err);
      }
    },
    // 修改其他设置信息
    async saveSysStaticData(formSave) {
      console.log(this.otherInfo, 11);
      const params = { ...formSave };
      params.switchParentPhoneNumber = this.otherInfo.switchParentPhoneNumber ? 1 : 0;
      params.switchCourseTeacher = this.otherInfo.switchCourseTeacher ? 1 : 0;
      params.switchOriginalSchool = this.otherInfo.switchOriginalSchool ? 1 : 0;
      console.log(params, 'params');
      try {
        this.$Spin.show();
        const res = await courseCenterApi.saveSysStaticDataNew(params);
        this.$Spin.hide();
        if (res.status === 200) {
          this.$Message.success('保存成功');
        }
      } catch (err) {
        this.$Spin.hide();
        console.log('err', err);
      }
    },
    // 同时段最大报名数 不限 切换
    onMaxCodChange(val) {
      // if (val) {
      //   this.formApply.numCod = 0;
      // }
    },
    handelSwitchSchool(index) { // 切换学校
      this.$store.dispatch('setSchoolIndex', index);
      this.$Message.success('切换成功');
    },
    handleSaveBtn() { // 保存按钮
      this.$refs.formApply.validate(valid => {
        if (valid) {
          const formSave = {};
          Object.assign(formSave, this.formApply);
          for (const key in formSave) {
            formSave[key] = (formSave[key] === '') ? null : formSave[key];
          }
          formSave.codeValue = this.schoolId;

          this.maxCod ? formSave.sameTimeEnrollLimit = '' : formSave.sameTimeEnrollLimit = (formSave.numCod === null ? '' : formSave.numCod);
          delete formSave.numCod;

          this.saveSysStaticData(formSave);
        } else {
          this.$Message.warning({ content: '表单验证失败' });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common';
.page-container {
  // height: 100%;
}
.course-others-title {
  background: #eef0f3;
  height: 40px;
  line-height: 40px;
  font-weight: 800;
  padding-left: 16px;
  border-radius: 5px;
}
.footer-hard {
  box-shadow: 0px 0px 3px #817d89;
  bottom: 16px;
  position: fixed;
  width: calc(100% - 304px);
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/ .ivu-form-item-error-tip {
  position: absolute;
  top: 5%;
  left: 60%;
  width: 100%;
  line-height: 1;
  padding-top: 6px;
  color: #ed4014;
}
.font-small {
  font-size: 10px;
}
.margin-left-16 {
  margin-left: 16px;
}
</style>
